<template>
  <div class="registerBox">
    <auth-logo />

    <div class="auth-logo-text">
      <div class="text">{{ $t.auth.logoText }}</div>
    </div>

    <van-tabs @click="onClick" v-model="active" class="loginTabs" animated>
      <van-tab :title="$t.auth.login"></van-tab>
      <van-tab :title="$t.auth.register"></van-tab>
    </van-tabs>

    <!-- 表单 -->
    <div class="formBox">
      <div class="radioBox">
        <van-radio-group v-model="auth.registerType" direction="horizontal">
          <!-- <van-radio :name="1" checked-color="#00e0b6">{{
            $t.auth.phoneNumber
          }}</van-radio> -->
          <van-radio :name="2" checked-color="#00e0b6">{{ $t.auth.email }}</van-radio>
        </van-radio-group>
      </div>
      <div class="inputBox" v-if="auth.registerType == 1">
        <input
          class="username"
          v-model="auth.phoneNumber"
          type="text"
          :placeholder="$t.auth.inputPhoneNumber"
        />
      </div>
      <div class="inputBox" v-if="auth.registerType == 2">
        <input
          class="username"
          v-model="auth.email"
          type="text"
          :placeholder="$t.auth.inputEmail"
        />
      </div>
      <div class="inputBox">
        <input
          class="password"
          v-model="auth.verificationCode"
          type="text"
          :placeholder="$t.auth.inputVcode"
        />
        <button class="getCode" v-if="isShowCode" @click="sendCode">
          {{ $t.auth.sendAuthCode }}
        </button>
        <div class="codeInfo" v-else>{{ timerNum }}S</div>
      </div>
      <div class="codeNotice">
        <div class="codeNoticeText">
          {{ $t.auth.codeNotice }}
        </div>
      </div>
      <div class="next" @click="next">{{ $t.auth.next }}</div>
    </div>
  </div>
</template>
<script>
import AuthLogo from "./components/AuthLogo";
import { Tab, Tabs, Checkbox, RadioGroup, Radio } from "vant";
import Vue from "vue";

Vue.use(Tab).use(Tabs).use(Checkbox).use(RadioGroup).use(Radio);
export default {
  name: "Register",
  components: {
    AuthLogo,
  },
  data() {
    return {
      active: 1,
      isShowCode: true, //实收显示获取验证码
      timerNum: 0,
      timerItem: null, //定时器对象
      auth: {
        registerType: 2,
        phoneNumber: "",
        email: "",
        password: "",
        verificationCode: "",
        companyCode: "",
        userId: null,
      },
    };
  },
  mounted() {
    const { CompanyCode, UserId } = this.$route.query;
    if (CompanyCode) {
      this.auth.companyCode = CompanyCode;
    }
    if (UserId) {
      this.auth.userId = UserId;
    }
  },
  methods: {
    next() {
      this.$commonMethod.showLoading();
      let param = {
        AccountType: this.auth.registerType,
        Phone: this.auth.phoneNumber,
        Email: this.auth.email,
        Code: this.auth.verificationCode,
      };
      this.$api.user
        .userSMSVerification(param)
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
            isParams: true,
            path: "auth/regInfo",
            name: "RegInfo",
            query: [
              {
                name: "RegisterType",
                value: param.AccountType,
              },
              {
                name: "PhoneNumber",
                value: param.Phone,
              },
              {
                name: "Email",
                value: param.Email,
              },
              {
                name: "VerificationCode",
                value: param.Code,
              },
              {
                name: "CompanyCode",
                value: this.auth.companyCode,
              },
              {
                name: "UserId",
                value: this.auth.userId,
              },
            ],
          });
          this.$commonMethod.hideLoading();
        })
        .catch((err) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    onClick(index) {
      if (index == 0) {
        if (this.auth.companyCode) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
            isParams: true,
            path: "auth/login",
            name: "Login",
            query: [
              {
                name: "CompanyCode",
                value: this.auth.companyCode,
              },
              {
                name: "UserId",
                value: this.auth.userId,
              },
            ],
          });
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
            isParams: false,
            path: "auth/login",
            name: "Login",
            query: [],
          });
        }
      }
    },
    sendCode() {
      const checkPhone = /^1[3|4|5|8][0-9]\d{4,8}$/;
      const phone = this.auth.phoneNumber;
      const checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const email = this.auth.email;
      if (this.auth.registerType == 1) {
        if (checkPhone.test(phone)) {
          this.sendVerificationCode();
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputCorrentPhoneNumber,
            type: "danger",
          });
        }
      }
      if (this.auth.registerType == 2) {
        if (checkEmail.test(email)) {
          this.sendVerificationCode();
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputCorrentEmail,
            type: "danger",
          });
        }
      }
    },
    sendVerificationCode() {
      this.$commonMethod.showLoading();
      var param = {
        AccountType: this.auth.registerType,
        Phone: this.auth.phoneNumber,
        Email: this.auth.email,
      };
      this.$api.user
        .sendVerificationCode(param)
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.verificationCodeInfo,
            type: "success",
          });
          //启动定时器
          this.timerTime();
          this.$commonMethod.hideLoading();
        })
        .catch((err) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    //定时器
    timerTime() {
      this.timerNum = 120;
      this.isShowCode = false;
      this.timerItem = setInterval(() => {
        this.timerNum--;
        if (this.timerNum < 1) {
          clearInterval(this.timerItem);
          this.isShowCode = true;
        }
      }, 1000);
    },
  },
  destroyed() {
    clearInterval(this.timerItem);
    this.timerItem = null;
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.registerBox {
  position: relative;
  width: 100%;
  .auth-logo-text {
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 2rem;
    .text {
      display: inline-block;
      vertical-align: middle;
      letter-spacing: 2px;
    }
  }
  .loginTabs {
    ::v-deep .van-tabs__nav {
      background: rgba(0, 0, 0, 0.1);
    }
    ::v-deep .van-tabs__wrap {
      width: 60%;
      border-radius: 10rem;
      margin: auto;
      border: none !important;
    }
    ::v-deep .van-tab {
      color: #fff;
      font-weight: bold;
    }
    ::v-deep .van-tab--active {
      border-radius: 10rem;
      background: #fff;
      color: #304156;
    }
    ::v-deep .van-hairline--top-bottom::after {
      display: none;
    }
    ::v-deep .van-tabs__line {
      display: none;
    }
    ::v-deep .van-tab__text {
      font-size: 1rem;
      line-height: 2;
      overflow: visible;
    }
  }
  //表单
  .formBox {
    width: 85%;
    position: relative;
    margin: 0 auto;
    margin-top: 2rem;
    .formTitle {
      width: 190px;
      border-radius: 50px;
      background-color: #ffffff;
      color: #304156;
      height: 24px;
      font-size: 26px;
      text-align: center;
      height: 70px;
      line-height: 70px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
    }
    .radioBox {
      text-align: center;
      .van-radio-group {
        display: inline-flex;
      }
      ::v-deep .van-radio__label {
        color: #fff;
      }
    }
    .inputBox {
      justify-content: space-between;
      align-items: center;
      margin-top: 18px;
      width: 100%;
      @include publicFlex;
      .username,
      .password {
        background: none;
        outline: none;
        border: none;
        -webkit-appearance: none; /*去除系统默认的样式*/
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/
        color: #f3faf8;
        font-size: 1rem;
        width: 100%;
        height: 50px;
        line-height: normal;
        border: 0.1rem solid #ffffff;
        border-radius: 100px;
        padding: 0 1.5rem;
        box-sizing: border-box;
        &::placeholder {
          color: #f3faf8;
          font-size: 1rem;
        }
        &::-webkit-input-placeholder {
          color: #f3faf8;
          font-size: 1rem;
        }
      }
      .getCode,
      .codeInfo {
        outline: none;
        border: 0;
        height: 50px;
        width: 185px;
        background-color: #ffffff;
        color: #304156;
        font-size: 0.8rem;
        text-align: center;
        border-radius: 80px;
        overflow: hidden;
        margin-left: 5%;
      }
      .codeInfo {
        font-size: 1rem;
        line-height: 50px;
        background-color: #dcdcdc;
        color: #ffffff;
      }
    }
    .codeNotice {
      margin-top: 15px;
      font-size: 12px;
      color: #ffffff;
      .codeNoticeText {
        text-align: right;
        vertical-align: middle;
      }
    }
    .next {
      width: 100%;
      border-radius: 50px;
      line-height: 50px;
      text-align: center;
      color: #304156;
      font-size: 1rem;
      font-weight: bold;
      background-color: #f3faf8;
      margin-top: 30px;
    }
    .InvitationCode {
      margin-top: 20px;
      font-size: 24px;
      width: 100%;
      height: 96px;
      line-height: 96px;
      border: 1px solid #b9e1da;
      border-radius: 100px;
      padding: 0 47px;
      box-sizing: border-box;
      color: #000000;
      color: rgba(0, 0, 0, 1);
      font-size: 30px;
      font-family: Helvetica;
      font-weight: 400;
      opacity: 0.3;
    }
    .forget {
      margin-top: 25px;
      color: #ffffff;
      text-align: center;
      font-size: 14px;
    }
  }
}
</style>
